export default __webpack_public_path__ + "static/media/Lose1.3a378c22.wav";